<template>
  <a-empty class="custom-empty" description="暂无数据"/>
</template>

<script>
export default {
  name: 'empty'
}
</script>

<style lang="less">
  .custom-empty{
    padding: 20px 0 0;
    .ant-empty-image{
      opacity: 0.4;
    }
    .ant-empty-description{
      color: #ccc;
    }
  }
</style>